export enum SubscriptionManageEventType {
  subscribed,
  unsubscribed,
  error,
  cancelled
}
